import { Button, Card, CardContent, CardMedia, Container, Divider, Grid, Link, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import '../Projects/Projects.css';
import ScrollToTop from "react-scroll-to-top";
// import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PersonIcon from '@mui/icons-material/Person';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import VisibilityIcon from '@mui/icons-material/Visibility';
import APIImg from '../../images/Javascript-API-Concept-DEV-Community-👩_💻👨_💻.png';

const projects = [
    {
        title: 'React Context API',
        image: 'https://res.cloudinary.com/practicaldev/image/fetch/s--YdrumP3U--/c_limit%2Cf_auto%2Cfl_progressive%2Cq_auto%2Cw_880/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/x13h42ls44fa1mbf4cjy.png',
        published: 'Dec 23, 2021',
        author: 'Md. Akramul Hoque',
        authorAvatar: 'https://res.cloudinary.com/practicaldev/image/fetch/s--SFzBgA5p--/c_fill,f_auto,fl_progressive,h_50,q_auto,w_50/https://dev-to-uploads.s3.amazonaws.com/uploads/user/profile_image/768775/c02728a5-8755-40a9-9f27-c534a79c0368.jpeg',
        live: 'https://dev.to/ahlikhon/react-context-api-2mbc',
        liked: 5,
        saved: 13,
        views: 1340,
        desc: 'Context API is a way to produce variables that can be passed around without having to pass props down manually at every level. Syntax is React.createConetxt(Provider, Consumer).',
    },
    {
        title: 'Node CRUD Operations',
        image: 'https://res.cloudinary.com/practicaldev/image/fetch/s--KiMUygG9--/c_limit%2Cf_auto%2Cfl_progressive%2Cq_auto%2Cw_880/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/rqqreyzyfpztn8az974c.png',
        published: 'Dec 23, 2021',
        author: 'Md. Akramul Hoque',
        authorAvatar: 'https://res.cloudinary.com/practicaldev/image/fetch/s--SFzBgA5p--/c_fill,f_auto,fl_progressive,h_50,q_auto,w_50/https://dev-to-uploads.s3.amazonaws.com/uploads/user/profile_image/768775/c02728a5-8755-40a9-9f27-c534a79c0368.jpeg',
        live: 'https://dev.to/ahlikhon/node-crud-operations-41k2',
        liked: 3,
        saved: 3,
        views: 66,
        desc: 'CRUD (create, read, update, delete) is an acronym that refers to the four functions. There are different requests for each issue. For querying, we have GET requests, for sending data we have POST requests. These are called HTTP requests. They enable interactions between client and the server and work as a request-response protocol.',
    },
    {
        title: 'Javascript API Concept',
        image: APIImg,
        published: 'Dec 21, 2021',
        author: 'Md. Akramul Hoque',
        authorAvatar: 'https://res.cloudinary.com/practicaldev/image/fetch/s--SFzBgA5p--/c_fill,f_auto,fl_progressive,h_50,q_auto,w_50/https://dev-to-uploads.s3.amazonaws.com/uploads/user/profile_image/768775/c02728a5-8755-40a9-9f27-c534a79c0368.jpeg',
        live: 'https://dev.to/ahlikhon/javascript-api-concept-2ccm',
        liked: 2,
        saved: 2,
        views: 36,
        desc: 'API: API stands for Application Programming Interface. An API is a set of defined rules that explain how computers and application servers communicate with each other. API can transfer data between an application and a web server.',
    },
]


const Blogs = () => {

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        // adaptiveHeight: true,
        // centerMode: true,
        // centerPadding: '60px',
        autoplay: true,
        autoplaySpeed: 2000,
    };
    // http://kenwheeler.github.io/slick/

    // const sampleJSON = {
    //     "name": "Md. Akramul Hoque",
    //     "same": "same",
    //     "age": "27",
    //     "school": "school",
    //     "location": "Feni",
    //     "5": "5",
    //     "number": 1,
    //     "14": "12"
    // };

    // const takeJSON = () => {

    //     // const JSONKeys = Object.keys(sampleJSON);
    //     // const JSONValues = Object.values(sampleJSON);
    //     const filterArr = Object.entries(sampleJSON).filter(val => val[0] !== val[1]);

    //     const ArrToObj = Object.fromEntries(filterArr);

    //     const JSONKeys = Object.keys(ArrToObj);
    //     const JSONValues = Object.values(ArrToObj);

    //     console.log(JSONKeys);
    //     console.log(JSONValues);

    //     // const newArray1 = JSONKeys.filter(val => !JSONValues.includes(val));
    //     // const newArray2 = JSONValues.filter(val => !JSONKeys.includes(val));
    //     // console.log(newArray1);
    //     // console.log(newArray2);

    //     return { JSONKeys, JSONValues };
    // }

    // takeJSON(sampleJSON);



    return (
        <Box id="blogs" sx={{ flexGrow: 1, py: 10, mt: { xs: '-1150px', md: '0px' } }}>
            <Container sx={{ textAlign: 'center', }}>
                <Typography sx={{ fontWeight: 500, letterSpacing: '2px' }} variant="h6" component="div">
                    BLOGS
                </Typography>
                <Divider sx={{ width: '100px', p: 0, m: '-2px auto', border: '1px solid #FFFFFF4E' }} />
                <Divider sx={{ width: '150px', p: 0, m: '4px auto 30px auto', border: '1px solid #FFFFFF4E' }} />
                <ScrollToTop smooth top="500" color="black" width="20" height="20" style={{ width: '30px', height: '30px', borderRadius: '30px', padding: '5px 5px 3px 4px', backgroundColor: 'rgba(255, 255, 255, 0.689)', }} />

                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>

                    {
                        projects.map(pr => (
                            <Grid data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1500"
                                item sx={{ mt: 1, }} xs={4} sm={4} md={4}>

                                <Card sx={{ maxWidth: { xs: 500, md: 900 }, position: 'relative', mx: 'auto', top: '0px', border: '1px solid #ffffff14', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px', color: 'rgba(255, 255, 255, 0.689)', backgroundColor: 'transparent', borderRadius: '0px 0px 3px 3px', }}>
                                    <CardMedia component="img"
                                        alt={pr.title}
                                        height="160"
                                        image={pr.image} />

                                    <CardContent sx={{ mt: '-10px', }}>
                                        <Typography sx={{ color: 'whitesmoke', fontWeight: '500' }} variant="h6" component="div">
                                            {pr.title}
                                        </Typography>
                                        <Divider sx={{ width: '100px', p: 0, m: '-2px auto', border: '1px solid #FFFFFF4E' }} />
                                        <Divider sx={{ width: '150px', p: 0, m: '4px auto', border: '1px solid #FFFFFF4E' }} />

                                        {/* detais */}
                                        <Box sx={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', flexWrap: 'wrap', mt: '15px', mb: '-8px' }}>
                                            <Button style={{ color: 'rgb(245 245 245 / 90%)', textTransform: 'capitalize', backgroundColor: 'transparent' }}>
                                                <PersonIcon sx={{ fontSize: '18px', mt: { xs: '-2px', md: '-5px' }, mr: '2px' }} /> {pr.author}
                                            </Button>
                                            <Button style={{ color: 'rgb(245 245 245 / 90%)', textTransform: 'capitalize', backgroundColor: 'transparent' }}>
                                                <QueryBuilderIcon sx={{ fontSize: '16px', mt: { xs: '0px', md: '-3px' }, mr: '2px' }} /> {pr.published}
                                            </Button>
                                        </Box>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', flexWrap: 'wrap', mt: '0px' }}>
                                            <Button style={{ color: 'rgb(245 245 245 / 90%)', textTransform: 'capitalize', backgroundColor: 'transparent' }}>
                                                <FavoriteBorderIcon sx={{ fontSize: '18px', mt: '-2px', mr: '2px' }} /> {pr.liked}
                                            </Button>
                                            <Button style={{ color: 'rgb(245 245 245 / 90%)', textTransform: 'capitalize', backgroundColor: 'transparent' }}>
                                                <BookmarkBorderIcon sx={{ fontSize: '18px', mt: '-2px', }} /> {pr.saved}
                                            </Button>
                                            <Button style={{ color: 'rgb(245 245 245 / 90%)', textTransform: 'capitalize', backgroundColor: 'transparent' }}>
                                                <VisibilityIcon sx={{ fontSize: '18px', mt: '-2px', mr: '2px' }} /> {pr.views}
                                            </Button>

                                            <Typography sx={{ my: 2, fontWeight: 300, letterSpacing: '1px', textAlign: 'justify' }} variant="p" component="div">
                                                {pr?.desc?.slice(0, 100)}............
                                            </Typography>
                                        </Box>

                                        <Link href={pr.live} target="_blank" underline="none">
                                            <Button style={{ width: '110px', textTransform: 'capitalize', fontSize: '16px', fontWeight: '500', backgroundColor: 'transparent', border: '1px solid #f5f5f596', color: 'rgba(255, 255, 255, 0.689)', }}>Read More</Button>
                                        </Link>


                                    </CardContent>
                                </Card>
                            </Grid>
                        ))
                    }
                </Grid>
            </Container>


            {/* <Slider style={{ width: '100%', margin: '30px auto', }} {...settings}>
                {
                    projects.map(pr => (
                        <div style={{ border: '2px solid red', padding: '10px' }}>
                            <img style={{ width: '500px' }} src={pr.image} />
                        </div>
                    ))
                }
            </Slider> */}
        </Box>
    );
};

export default Blogs;